document.addEventListener('DOMContentLoaded', function () {

  // ── HAMBURGER MENU ──
  const menuOpen = document.getElementById('menu-open');
  const menuClose = document.getElementById('menu-close');
  const menuPanel = document.getElementById('menu-panel');
  const menuOverlay = document.getElementById('menu-overlay');
  const mainNav = document.getElementById('main-nav');

  if (menuOpen && menuPanel) {
    function openMenu() {
      menuPanel.classList.add('open');
      if (menuOverlay) menuOverlay.classList.add('open');
      if (mainNav) mainNav.classList.add('menu-active');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      menuPanel.classList.remove('open');
      if (menuOverlay) menuOverlay.classList.remove('open');
      if (mainNav) mainNav.classList.remove('menu-active');
      document.body.style.overflow = '';
    }

    menuOpen.addEventListener('click', openMenu);
    if (menuClose) menuClose.addEventListener('click', closeMenu);
    if (menuOverlay) menuOverlay.addEventListener('click', closeMenu);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
  }

  // ── MOBILE GALLERY DOTS ──
  const gallery = document.getElementById('gallery');
  const dots = document.querySelectorAll('.gallery-dot');

  if (gallery && dots.length) {
    function updateDots() {
      const index = Math.round(gallery.scrollLeft / gallery.offsetWidth);
      dots.forEach(function (d, i) { d.classList.toggle('active', i === index); });
    }

    gallery.addEventListener('scroll', updateDots, { passive: true });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        gallery.scrollTo({ left: parseInt(dot.dataset.index) * gallery.offsetWidth, behavior: 'smooth' });
      });
    });
  }

  // ── GALLERY ARROWS (mobile) ──
  const prevBtn = document.getElementById('gallery-prev');
  const nextBtn = document.getElementById('gallery-next');

  if (prevBtn && nextBtn && gallery) {
    prevBtn.addEventListener('click', function () {
      gallery.scrollBy({ left: -gallery.offsetWidth, behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      gallery.scrollBy({ left: gallery.offsetWidth, behavior: 'smooth' });
    });
  }

  // ── VARIANT SELECTION (color + size) ──
  var variantInput = document.getElementById('variant-id');
  var variants = window.__LN_variants || [];

  function getSelectedColor() {
    var active = document.querySelector('.color-swatch.active');
    return active ? active.dataset.color : null;
  }

  function getSelectedSize() {
    var active = document.querySelector('.size-btn.active');
    return active ? active.dataset.size : null;
  }

  function updateVariant() {
    if (!variantInput || !variants.length) return;
    var color = getSelectedColor();
    var size = getSelectedSize();

    var match = variants.find(function (v) {
      var opts = (v.options || []).map(function (o) { return o.toLowerCase(); });
      var colorMatch = color ? opts.indexOf(color.toLowerCase()) !== -1 : true;
      var sizeMatch  = size  ? opts.indexOf(size.toLowerCase())  !== -1 : true;
      return colorMatch && sizeMatch;
    });

    if (match) variantInput.value = match.id;
  }

  // Color swatches
  document.querySelectorAll('.color-swatch').forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      document.querySelectorAll('.color-swatch').forEach(function (s) { s.classList.remove('active'); });
      swatch.classList.add('active');
      var label = document.getElementById('color-name');
      if (label) label.textContent = swatch.dataset.name;
      updateVariant();
    });
  });

  // Size buttons
  document.querySelectorAll('.size-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.size-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var label = document.getElementById('size-name');
      if (label) label.textContent = btn.dataset.size;
      updateVariant();
    });
  });

  // Set initial variant
  updateVariant();

});

// ── ACCORDION ──
function toggleAccordion(header) {
  var body = header.nextElementSibling;
  var icon = header.querySelector('.accordion-icon');
  var isOpen = body.classList.contains('open');
  document.querySelectorAll('.accordion-body').forEach(function (b) { b.classList.remove('open'); });
  document.querySelectorAll('.accordion-icon').forEach(function (i) { i.textContent = '+'; });
  if (!isOpen) {
    body.classList.add('open');
    if (icon) icon.textContent = '−';
  }
}
